import styled from 'styled-components';
import { Icon, IconSize, MinimalIconProps } from '@ardoq/icons';
import { colors, space } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';

export type FilterPillLabelProps = {
  label: string;
  icon?: MinimalIconProps;
};

const FilterPillLabelIcon = styled(Icon)`
  padding-left: ${space.xxsmall};
`;
export const FilterPillLabel = ({ label, icon }: FilterPillLabelProps) => (
  <FlexBox gap="xsmall" align="center" paddingX="small" paddingY="xsmall">
    {icon?.name && (
      <FilterPillLabelIcon
        iconName={icon.name}
        iconSize={IconSize.SMALL}
        color={colors.icon}
      />
    )}
    {label}
  </FlexBox>
);
